import { EMAIL_DOMAIN_REGEX } from "~/utils/constants";

export function validateEmail(emailValue: string): string {
  const trimmedEmail = emailValue.trim();
  if (!trimmedEmail) {
    return "Email address is required";
  }
  if (trimmedEmail.includes(" ")) {
    return "Please enter a valid email address format";
  }
  const atIndex = trimmedEmail.indexOf("@");
  if (atIndex <= 0) {
    return "Please enter a valid email address format";
  }
  const domain = trimmedEmail.substring(atIndex + 1);
  if (!EMAIL_DOMAIN_REGEX.test(domain)) {
    return "Please enter a valid email address format";
  }
  return "";
}

export function isValidEmail(email: string): boolean {
  const trimmedEmail = email.trim();
  if (trimmedEmail.includes(" ")) {
    return false;
  }
  const atIndex = trimmedEmail.indexOf("@");
  if (atIndex <= 0) {
    return false;
  }
  const domain = trimmedEmail.substring(atIndex + 1);
  return EMAIL_DOMAIN_REGEX.test(domain);
}
